import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    containedSizeLarge: {
      padding: '14px 30px',
    },
    contained: {
      borderRadius: '4px',
      backgroundColor: accentColor,
      lineHeight: '1.2',
      color: theme.colors.white,
      letterSpacing: '0.8px',
      filter: 'brightness(1)',
      transition: 'filter .3s',
      '&:hover': {
        backgroundColor: accentColor,
        filter: 'brightness(1.3)',
      },
    },
    outlined: {
      borderColor: accentColor,
      color: accentColor,
      '&:hover': {
        borderColor: `${accentColor} !important`,
        color: accentColor,
      },
    },
  }
}
